import PropTypes from 'prop-types';
import { replaceUrls } from '../../utils';

const ArticleContent = ({ content, postTakeover }) => {
  const s = require('./article.module.scss');
  return (
    <div className={postTakeover ? s.TakeoverWrapper : s.Wrapper}>
      <div className={postTakeover ? s.PostTakeoverContent : s.Content} dangerouslySetInnerHTML={{ __html: replaceUrls(content) }} />
    </div>
  );
};

ArticleContent.propTypes = {
  content: PropTypes.string,
  postTakeover: PropTypes.bool,
};

export default ArticleContent;

